import React, {useEffect, useState} from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes as Switch,
  Navigate,
} from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.css";
import "./App.css";

import SuperProvider from "./Context/SuperProvider";
import Dashboard from "./Pages/Dashboard";
import LoginPage from "./Pages/LoginPage";
import AddGroup from "./Components/StudentGroups/AddStudentSchoolGroup";
import functions from "./util/functions";
import ActivateAccount from "./Pages/ActivateAccount";
import Profile from "./Pages/Profile";
import SchoolDashboard from "./Pages/SchoolDashboard";
import CallLogsPage from "./Pages/CallLogsPage";
import CardsPage from "./Pages/CardsPage";
import ListAdminsPage from "./Pages/SystemUsers/AdminPanel/ListAdminsPage";
import ListSchoolAdminsPage from "./Pages/SystemUsers/AdminPanel/ListSchoolAdminsPage";
import CallStationsPage from "./Pages/CallingStation/AdminPanel/CallStationsPage";
import SchoolStationsPage from "./Pages/CallingStation/SchoolAdminPanel/SchoolStationsPage";
import SettingsPage from "./Pages/Settings/SettingsPage";
import ChargeRatesPage from "./Pages/Settings/ChargeRatesPage";
import DistrictsPage from "./Pages/Settings/DistrictsPage";
import RegionsPage from "./Pages/Settings/RegionsPage";
import ViewSchoolsPage from "./Pages/Schools/ViewSchoolsPage";
import RegisterSchoolPage from "./Pages/Schools/RegisterSchoolPage";
import SchoolProfilePage from "./Pages/Schools/SchoolProfilePage";
import DeletedUsersPage from "./Pages/Parents/AdminProfile/DeletedUsersPage";
import SchoolParentProfilePage from "./Pages/Parents/SchoolAdminProfile/SchoolParentProfilePage";
import ParentProfilePage from "./Pages/Parents/AdminProfile/ParentProfilePage";
import ViewSchoolParentsPage from "./Pages/Parents/SchoolAdminProfile/ViewSchoolParentsPage";
import ViewParentsPage from "./Pages/Parents/AdminProfile/ViewParentsPage";
import ViewStudentsPage from "./Pages/Students/AdminProfile/ViewStudentsPage";
import TransferStudentPage from "./Pages/Students/TransferStudentPage";
import ImportStudentsPage from "./Pages/Students/AdminProfile/ImportStudentsPage";
import ImportStudentsandContactsPage from "./Pages/Students/AdminProfile/ImportStudentsandContactsPage";
import StudentProfilePage from "./Pages/Students/StudentProfilePage";
import ViewSchoolStudentsPage from "./Pages/Students/SchoolAdminProfile/ViewSchoolStudentsPage";
import ImportSchoolStudentsPage from "./Pages/Students/SchoolAdminProfile/ImportSchoolStudentsPage";
import ListGroupsPage from "./Pages/StudentGroups/ListGroupsPage";
import StudentsInGroupPage from "./Pages/StudentGroups/StudentsInGroupPage";
import GenerateQRCodesPage from "./Pages/GenerateQRCodesPage";
import ListVendorsPage from "./Pages/SystemUsers/AdminPanel/Vendor/ListVendorsPage";
import VendorProfilePage from "./Pages/SystemUsers/AdminPanel/Vendor/VendorProfilePage";
import MobileMoneyPage from "./Pages/Transactions/MobileMoneyPage";
import PocketMoneyPage from "./Pages/Transactions/PocketMoneyPage";
import BuzztimeChargesPage from "./Pages/Transactions/BuzztimeChargesPage";
import AccountActivationsPage from "./Pages/Statistics/AccountActivationsPage";
import BalancesStatement from "./Components/Statistics/CreditBalances/BalancesStatement";
import PocketMoneyBalancesStatement from "./Components/Statistics/PocketMoneyBalances/PocketMoneyBalancesStatement";
import PocketMoneyBalancesPage from "./Pages/Statistics/AdminProfile/PocketMoneyBalancesPage";
import BuzztimeCreditBalancesPage from "./Pages/Statistics/AdminProfile/BuzztimeCreditBalancesPage";
import SchoolBuzztimeCreditBalancesPage from "./Pages/Statistics/SchoolAdminProfile/SchoolBuzztimeCreditBalancesPage";
import SchoolPocketMoneyBalancesPage from "./Pages/Statistics/SchoolAdminProfile/SchoolPocketMoneyBalancesPage";
import InactiveStudentsPage from "./Pages/Statistics/AdminProfile/InactiveStudentsPage";
import MessageStatisticsPage from "./Pages/Statistics/AdminProfile/MessageStatisticsPage";
import CardReplacementsPage from "./Pages/Statistics/AdminProfile/CardReplacementsPage";
import ParentCreditBalancesPage from "./Pages/Statistics/AdminProfile/ParentCreditBalancesPage";
import MMChargesPage from "./Pages/Transactions/MMChargesPage";
import ErrorPage from "./Pages/ErrorPage";
import AppUpdatePage from "./Pages/Settings/AppUpdatePage";
import VendorFloatBalancesPage from "./Pages/Statistics/AdminProfile/VendorFloatBalancesPage";
import PocketMoneySettingsPage from "./Pages/Settings/PocketMoneySettingsPage";
import CommunicationSettingsPage from "./Pages/Settings/CommunicationSettingsPage";
import VendorBalancesStatement from "./Components/Statistics/VendorBalances/VendorBalancesStatement";
import SearchStudentsPage from "./Pages/Students/AdminProfile/SearchStudentsPage";
import SearchSchoolStudentsPage from "./Pages/Students/SchoolAdminProfile/SearchSchoolStudentsPage";
import AuthenticationSettingsPage from "./Pages/Settings/AuthenticationSettingsPage";
import SchoolCallLogsPage from "./Pages/SchoolCallLogsPage";
import PendingAttachments from "./Pages/StudentCards/SchoolAdminProfile/PendingAttachments";
import SchoolCardsPage from "./Pages/StudentCards/SchoolAdminProfile/SchoolCardsPage";
import AllPendingAttachments from "./Pages/StudentCards/AdminProfile/AllPendingAttachments";
import TermsPage from "./Pages/Settings/TermsPage";
import TermlyFeesPage from "./Pages/Statistics/AdminProfile/TermlyFeesPage";
import VendorCommissionsPage from "./Pages/Statistics/AdminProfile/VendorCommissionsPage";
import CommissionBalancesStatement from "./Components/Statistics/CommissionBalances/CommissionBalancesStatement";
import DepositChargesPage from "./Pages/Transactions/DepositChargesPage";
import NoPhotoStudentsPage from "./Pages/Students/AdminProfile/NoPhotoStudentsPage";
import NoPrintStudentsPage from "./Pages/Students/AdminProfile/NoPrintStudentsPage";
import NoContactsPage from "./Pages/Students/AdminProfile/NoContactsPage";
import FingerprintNotificationPage from "./Pages/Settings/FingerprintNotificationPage";
import ActiveStudentsPage from "./Pages/Statistics/AdminProfile/ActiveStudentsPage";
import UpdateFaceStatusPage from "./Pages/Settings/UpdateFaceStatusPage";
import NoFacesPage from "./Pages/Students/AdminProfile/NoFacesPage";
import ActivationBonusStudentsPage from "./Pages/Statistics/AdminProfile/ActivationBonusStudentsPage";
import DormantAccountsPage from "./Pages/Statistics/AdminProfile/DormantAccountsPage";
import SchoolDormantAccountsPage from "./Pages/Statistics/SchoolAdminProfile/SchoolDormantAccountsPage";


function App() {
  const [loggedIn, setLoggedIn] = useState(true);

  useEffect(() => {
    checkLogin();
  }, []);

  function checkLogin() {
    if (!window.localStorage.getItem("buzzMe@user")) {
      setLoggedIn(false);
    } else {
      setLoggedIn(true);
    }
  }

  const role = functions.checkRole();
  const secure = functions.checkSecureAccount();


  return (
    <SuperProvider>
      <Router forceRefresh={false}>
        <Switch>
          {!loggedIn && (
            <>
              <Route path="*" element={<LoginPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={
                  !loggedIn ? <Navigate replace to="/login" /> : <Dashboard />
                }
              />
            </>
          )}

          {loggedIn && secure * 1 === 0 && (
            <>
              <Route path="/Activate/account" element={<ActivateAccount />} />
              <Route
                path="/"
                element={<Navigate replace to="/Activate/account" />}
              />
            </>
          )}
          {loggedIn && role * 1 < 3 && (
            <>
              <Route path="*" element={<Dashboard />} />
              <Route path="/" element={<Dashboard />} />
              <Route path="/students/register" element={<ErrorPage />} />
              <Route path="/students" element={<ViewStudentsPage />} />
              <Route path="/contacts" element={<ViewParentsPage />} />
              <Route path="/call-logs" element={<CallLogsPage />} />
              <Route path="/stations" element={<CallStationsPage />} />
              <Route path="/students_contacts/upload" element={<ImportStudentsandContactsPage />} />
              <Route path="/students/upload" element={<ImportStudentsPage />} />
              <Route path="/pocket-money-balances" element={<PocketMoneyBalancesPage/>} />
              <Route path="/credit-balances" element={<BuzztimeCreditBalancesPage/>} />
              <Route path="/inactive-students" element={<InactiveStudentsPage/>} />
              <Route path="/credit-balances/parents" element={<ParentCreditBalancesPage/>} />
              <Route path="/mm-charges/list" element={<MMChargesPage/>} />
              <Route path="/vendor-balances" element={<VendorFloatBalancesPage/>} />
              <Route path="/students/search" element={<SearchStudentsPage/>} />
              <Route path="/account-activations" element={<AccountActivationsPage/>} />
               <Route path="/mm/list" element={<MobileMoneyPage />} />
               <Route path="/vendors" element={<ListVendorsPage/>} />
              <Route path="/vendors/profile/:id/:user_id" element={<VendorProfilePage />} />
              <Route path="/vendor-balances/statement/:id" element={<VendorBalancesStatement/>} />
              <Route path="/credit-balances/statement/:id" element={<BalancesStatement/>} />
              <Route path="/pocket-money-balances/statement/:id" element={<PocketMoneyBalancesStatement/>} />
              <Route path="/pending-buzz-cards" element={<AllPendingAttachments />} />
              <Route path="/school-terms" element={<TermsPage/>} />
              <Route path="/termly-fees" element={<TermlyFeesPage/>} />
              <Route path="/vendor-commissions" element={<VendorCommissionsPage/>} />
              <Route path="/vendor-commissions/statement/:id" element={<CommissionBalancesStatement/>} />
              <Route path="/deposit-charges/list" element={<DepositChargesPage/>} />
              <Route path="/students/no_photo" element={<NoPhotoStudentsPage/>} />
              <Route path="/students/no_print" element={<NoPrintStudentsPage/>} />
              <Route path="/students/no_contact" element={<NoContactsPage/>} />
              <Route path="/active-students" element={<ActiveStudentsPage/>} />
              <Route path="/students/import/face" element={<UpdateFaceStatusPage />} />
              <Route path="/students/no_face" element={<NoFacesPage/>} />
              <Route path="/students/activation-bonus" element={<ActivationBonusStudentsPage/>} />
              <Route path="/dormant-accounts" element={<DormantAccountsPage/>} />



              <Route
                path="/"
                element={
                  !loggedIn ? <Navigate replace to="/login" /> : <Dashboard />
                }
              />
              <Route
                path="/login"
                element={loggedIn ? <Navigate replace to="/" /> : <LoginPage />}
              />
            </>
          )}

          {loggedIn && role * 1 === 3 && (
            <>
              <Route path="*" element={<SchoolDashboard />} />
              <Route path="/" element={<SchoolDashboard />} />
              <Route path="/students/register" element={<ErrorPage />} />
              <Route path="/students" element={<ViewSchoolStudentsPage />} />
              <Route path="/contacts" element={<ViewSchoolParentsPage />} />
              <Route path="/stations" element={<SchoolStationsPage />} />
              <Route path="/call-logs" element={<SchoolCallLogsPage />} />
              <Route path="/pocket-money-balances" element={<SchoolPocketMoneyBalancesPage/>} />
              <Route path="/credit-balances" element={<SchoolBuzztimeCreditBalancesPage/>} />
              <Route path="/pending-school-buzz-cards" element={<PendingAttachments />} />
              <Route path="/dormant-accounts" element={<SchoolDormantAccountsPage/>} />
              <Route
                path="/"
                element={
                  !loggedIn ? <Navigate replace to="/login" /> : <SchoolDashboard />
                }
              />
              <Route
                path="/login"
                element={loggedIn ? <Navigate replace to="/" /> : <LoginPage />}
              />
              <Route path="/students/search" element={<SearchSchoolStudentsPage/>} />
            </>
          )}

          {loggedIn && (
            <>
              
              {/* School routes */}
              <Route path="/schools/view" element={<ViewSchoolsPage />} />
              <Route path="/schools/add" element={<RegisterSchoolPage />} />
              <Route
                path="/schools/view/profile/:id"
                element={<SchoolProfilePage />}
              />
              {/* End school routes */}
              {/* School User routes */}
              <Route path="/admin/view" element={
                  !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <ListAdminsPage />
                } />
              <Route
                path="/school_admin/view"
                element={<ListSchoolAdminsPage />}
              />
              {/* End School User routes */}
              {/* Charge rate routes */}
              <Route path="/rates" element={
                  !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <ChargeRatesPage/>
                } />
              {/* End Charge rate routes */}
              {/* Parents */}
             
              
              <Route path="/parents/profile/:id/:user_id" element={<ParentProfilePage />} />
              <Route path="/school-parents/profile/:parent/:user_id" element={<SchoolParentProfilePage />} />
              {/* End parent */}
              {/* Students */}
              
              
              <Route path="/students/import" element={<ImportSchoolStudentsPage />} />
              <Route
                path="/students/profile/:student_id/:user_id"
                element={<StudentProfilePage />}
              />
              <Route
                path="/school-students/profile/:student_id/:user_id"
                element={<StudentProfilePage />}
              />
              {/* End student */}
              {/* Class Groups */}
              <Route path="/class-groups" element={<ListGroupsPage />} />
              
              <Route path="/class-groups/add" element={<AddGroup />} />
              <Route
                path="/class-groups/view/:id"
                element={<StudentsInGroupPage />}
              />
              {/* End class groups */}
              {/* districts and regions*/}
              <Route path="/districts" element={<DistrictsPage />} />
              <Route path="/regions" element={<RegionsPage />} />
              {/* End class groups */}
              <Route path="/profile" element={<Profile />} />
              {/* <Route path="/settings" element={<SettingsPage />} /> */}
              <Route path="/error-page" element={<ErrorPage />} />

              <Route
                path="/settings"
                element={
                  !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <SettingsPage/>
                }
              />
              {/* <Route path="/buzz-cards" element={<CardsPage/>} /> */}
              <Route path="/buzz-cards" element={
                  !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <CardsPage/>
                } />
              <Route path="/students/transfer" element={<TransferStudentPage />} />
              <Route path="/deleted-users" element={<DeletedUsersPage />} />

              <Route path="/cards/print" element={<GenerateQRCodesPage />} />
              
             
              <Route path="/buzz-cards" element={
                  !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <CardsPage/>
                } />
              <Route path="/pocket-money/list" element={<PocketMoneyPage />} />
              <Route path="/buzztime-charges/list" element={<BuzztimeChargesPage />} />
              <Route path="/school-buzz-cards" element={<SchoolCardsPage/>} />

              
              
              <Route path="/students/group/:id" element={<StudentsInGroupPage/>} />
              
              <Route path="/message-stats" element={<MessageStatisticsPage/>} />
              <Route path="/card-replacements" element={<CardReplacementsPage/>} />
              <Route path="/app-update" element={<AppUpdatePage />} />

              <Route path="/pocket-money-settings" element={
                                !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <PocketMoneySettingsPage/>
                              } />
              <Route path="/communication-settings" element={
                                !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <CommunicationSettingsPage/>
                              } />
              
              <Route path="/authentication-settings" element={
                                !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <AuthenticationSettingsPage/>
                              } />
              <Route path="/school-terms" element={
                                !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <TermsPage/>
                              } />
              <Route path="/termly-fees" element={
                                !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <TermlyFeesPage/>
                              } />
              <Route path="/fingerprint-notifs" element={
                                !(role * 1 < 3) ? <Navigate replace to="/error-page" /> : <FingerprintNotificationPage/>
                              } />
            </>
          )}
        </Switch>
      </Router>
    </SuperProvider>
  );
}

export default App;
